import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { cn } from './lib/utils';
import AppHeader from './components/AppHeader';
import BottomNav from './components/BottomNav';
import AppFooter from './components/AppFooter';

// Pages
import Home from './pages/Home';
import ShopPage from './pages/ShopPage';
import ProductDetailPage from './pages/ProductDetailPage';
import Motorcycles from './pages/Motorcycles';
import MotorcycleDetail from './pages/MotorcycleDetail';

// Admin
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import ProductList from './pages/admin/ProductList';
import ProductForm from './pages/admin/ProductForm';
import MotorcycleList from './pages/admin/MotorcycleList';
import MotorcycleForm from './pages/admin/MotorcycleForm';
import MakesAdmin from './pages/admin/MakesAdmin';
import ModelsAdmin from './pages/admin/ModelsAdmin';
import CarouselAdmin from './pages/admin/CarouselAdmin';

function LayoutWrapper() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdmin && <AppHeader />}
      <main className="flex-1 pb-16 md:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/motorcycles" element={<Motorcycles />} />
          <Route path="/motorcycles/:id" element={<MotorcycleDetail />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<ProductList />} />
            <Route path="products/add" element={<ProductForm />} />
            <Route path="products/:id/edit" element={<ProductForm />} />
            <Route path="motorcycles" element={<MotorcycleList />} />
            <Route path="motorcycles/add" element={<MotorcycleForm />} />
            <Route path="motorcycles/:id/edit" element={<MotorcycleForm />} />
            <Route path="makes" element={<MakesAdmin />} />
            <Route path="settings/makes" element={<MakesAdmin />} />
            <Route path="settings/makes/add" element={<MakesAdmin />} />
            <Route path="settings/makes/:id/edit" element={<MakesAdmin />} />
            <Route path="settings/models" element={<ModelsAdmin />} />
            <Route path="settings/models/add" element={<ModelsAdmin />} />
            <Route path="settings/models/:id/edit" element={<ModelsAdmin />} />
            <Route path="carousel" element={<CarouselAdmin />} />
          </Route>
        </Routes>
      </main>
      {!isAdmin && <AppFooter />}
      {!isAdmin && <BottomNav />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className={cn("min-h-screen flex flex-col")}>
        <LayoutWrapper />
      </div>
    </BrowserRouter>
  );
}

export default App;